(function () {
  angular.module('app.core.api.interceptor', ['binky.core.lodash']);
})();
